import {modalHandler} from './Modals';

export default function popups() {
    document.addEventListener(window.kunstmaan.leadGeneration.events.BEFORE_SHOWING, showPopup);
}

function showPopup(e) {
    const otherModalOpen = document.querySelector('.html--modal--open');

    if (!otherModalOpen) { // only open if no other modal is open
        const encodedName = encodeURIComponent(e.detail.popup);
        const popup = document.querySelector(`[data-popup-name="${encodedName}"]`);

        modalHandler(popup);
    }
}



// WEBPACK FOOTER //
// ./src/Will/WebsiteBundle/Resources/ui/js/Popups.js